import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthUser } from '../../models/auth-user.model';
import { ApiService } from '../../services/api.service';
import { SidenavService } from '../../services/sidenav.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
  @Input() user: AuthUser | null = null;
  @Input() isAdmin: boolean = false;
  @Input() version: string = '';

  @Output() userChanged = new EventEmitter<AuthUser>();

  constructor(
    private router: Router,
    private apiService: ApiService,
    private sidenavService: SidenavService,
  ) {}

  goToPage(path: string): void {
    this.router.navigate([path], { replaceUrl: true });
    const sidenav = this.sidenavService.getSidenav();
    if (sidenav?.mode === 'over') {
      sidenav.close();
    }
  }

  fileBrowseHandler(event: Event): void {
    if (!this.user?._id) return;
    const files = (event.target as HTMLInputElement).files;
    if (files?.length === 1 && files[0].type.startsWith('image/')) {
      this.apiService
        .uploadFile(`/users/upload-avatar/${this.user._id}`, files[0])
        .then((user) => this.userChanged.emit(user as AuthUser));
    }
  }
}
